export enum MaintenanceEnum {
  // 将要维护
  WILL_MAINTENANCE = 0,
  // 维护中
  IN_PROGRESS = 1,
  // 已结束
  FINISHED = 2,
}
